export const todos = [
    {
        id: 'todolist11',
        title: 'Missed Intros',
        dueDate: '2022/11/5',
        completed: false,
        assets: [
            {
                id: 'todoasset11',
                title: 'New Hire Training - Refresher',
                type: 'video',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
            },
            {
                id: 'todoasset12',
                title: 'CSAT Champions Call #1',
                type: 'presentation',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
            },
            {
                id: 'todoasset13',
                title: 'CSAT Champions Call #2',
                type: 'document',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
            },
            {
                id: 'todoasset14',
                title: 'Language Best Practices',
                type: 'video',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
            },
            {
                id: 'todoasset15',
                title: 'Sample Practice Script',
                type: 'document',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://google.com'
            }
        ]
    },
    {
        id: 'todolist12',
        title: 'Missed Salutations',
        dueDate: '2022/11/1',
        completed: true,
        assets: [
            {
                id: 'todoasset11',
                title: 'New Hire Training - Refresher',
                type: 'video',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: true,
                link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
            },
            {
                id: 'todoasset12',
                title: 'CSAT Champions Call #1',
                type: 'presentation',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: true,
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
            },
            {
                id: 'todoasset13',
                title: 'CSAT Champions Call #2',
                type: 'document',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: true,
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
            },
            {
                id: 'todoasset14',
                title: 'Language Best Practices',
                type: 'video',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: true,
                link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
            },
            {
                id: 'todoasset15',
                title: 'Sample Practice Script',
                type: 'document',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: true,
                link: 'https://google.com'
            }
        ]
    },
    {
        id: 'todolist13',
        title: 'Dead Air',
        dueDate: '2022/11/30',
        completed: false,
        assets: [
            {
                id: 'todoasset11',
                title: 'New Hire Training - Refresher',
                type: 'video',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
            },
            {
                id: 'todoasset12',
                title: 'CSAT Champions Call #1',
                type: 'presentation',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
            },
            {
                id: 'todoasset13',
                title: 'CSAT Champions Call #2',
                type: 'document',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
            },
            {
                id: 'todoasset14',
                title: 'Language Best Practices',
                type: 'video',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
            },
            {
                id: 'todoasset15',
                title: 'Sample Practice Script',
                type: 'document',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://google.com'
            }
        ]
    },
    {
        id: 'todolist14',
        title: 'Hold Etiquette',
        dueDate: '2022/12/12',
        completed: false,
        assets: [
            {
                id: 'todoasset11',
                title: 'New Hire Training - Refresher',
                type: 'video',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
            },
            {
                id: 'todoasset12',
                title: 'CSAT Champions Call #1',
                type: 'presentation',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
            },
            {
                id: 'todoasset13',
                title: 'CSAT Champions Call #2',
                type: 'document',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
            },
            {
                id: 'todoasset14',
                title: 'Language Best Practices',
                type: 'video',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
            },
            {
                id: 'todoasset15',
                title: 'Sample Practice Script',
                type: 'document',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://google.com'
            }
        ]
    },
    {
        id: 'todolist15',
        title: 'Tone/Empathy',
        dueDate: '2022/11/12',
        completed: false,
        assets: [
            {
                id: 'todoasset11',
                title: 'New Hire Training - Refresher',
                type: 'video',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
            },
            {
                id: 'todoasset12',
                title: 'CSAT Champions Call #1',
                type: 'presentation',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
            },
            {
                id: 'todoasset13',
                title: 'CSAT Champions Call #2',
                type: 'document',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
            },
            {
                id: 'todoasset14',
                title: 'Language Best Practices',
                type: 'video',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
            },
            {
                id: 'todoasset15',
                title: 'Sample Practice Script',
                type: 'document',
                description: 'Lorem ipsum dolor sit amet consectetur. Tempus tristique arcu proin risus sollicitudin',
                started: false,
                completed: false,
                link: 'https://google.com'
            }
        ]
    },
]